
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGenericLineCross as ObiGenericLineCrossElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-generic-line-cross.js';
 
 
 

 
 export const ObiGenericLineCross = createComponent({
   react: React,
   tagName: 'obi-generic-line-cross',
   elementClass: ObiGenericLineCrossElement,
   events: {
     
   }
  });
 
 